import lang from '@/lang'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'
import React from 'react'
import { Route } from 'react-router'

const SupplierList = React.lazy(() => import('./components/list/supplier-list'))
const SupplierDetail = React.lazy(() => import('./components/detail/supplier-detail'))
const SupplierEdit = React.lazy(() => import('./components/edit/supplier-edit'))

const supplierRoutes = (
  <>
    <Route path='supplier/*' element={<RedirectToPlural />} />
    <Route path='suppliers' Component={SupplierList} handle={{ title: lang.suppliersLabel, options: { noBackgroundColor: true } }} />
    <Route path='suppliers/:id' Component={SupplierDetail} />
    <Route path='suppliers/edit/:id/:hash?' Component={SupplierEdit} />
    <Route path='suppliers/new' Component={SupplierEdit} />
  </>
)

export default supplierRoutes
